import * as React from 'react';
import {
  Button,
  Container,
  FileUpload,
  FormField,
  Header,
  Input,
  Modal,
  SpaceBetween,
  Spinner,
  TextContent
} from '@cloudscape-design/components';
import { DocumentContext } from '../../../context/documentContext';
import { createParagraphs } from '../../../helpers/getFileData';
import { useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { BaseRow, Importer, ImporterField } from 'react-csv-importer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DOCTYPE } from '../../../lib/models/interfaces';
import axios from 'axios';
import { UserContext } from '../../../context/authContext';
import { isEncrypted } from '../../../helpers/determineEncrypted';
import {
  detectFileType,
  getPDFPageCount
} from '../../../helpers/determineFileType';
import { useAlert } from '../../../context/alertContext';
import logger from '../../../helpers/Logger';
import { v4 as uuidv4 } from 'uuid';
import {
  createWSConnection,
  getDOCXPageCount,
  waitForMessage
} from './wsHelpers';
import { KoruLoading } from '../shared/KoruLoading';
import { useDropzone } from 'react-dropzone';

interface Props {
  type: string | null;
  projectId: string;
  folderId: string;
  handleModalCancel?: (arg: boolean) => void;
}
export const FileSelector = (props: Props) => {
  const [value, setValue] = useState<File[]>([]);
  const [docProcessing, setDocProcessing] = useState<boolean>(false);
  const {
    setFilesToUpload,
    setUploadProcessing,
    uploadProcessing,
    uploadFiles,
    qaOrigin,
    qaContact,
    setMainAlert,
    getAllDocs
  } = useContext(DocumentContext);
  const { auth, user, subscription, token } = useContext(UserContext);
  const { setAlert, setSubsAlert } = useAlert();
  const navigate = useNavigate();
  const [csvRowsArray, setCSVRowsArray] = useState<any[]>([]);
  const [fileError, setFileError] = useState<string[]>([]);
  const [allowUpload, setAllowUpload] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [determinedFileType, setDeterminedFileType] = useState<{
    mime: string;
    ext: string;
  } | null>(null);
  const [fileTypeArray, setFileTypeArray] = useState<
    ({ mime: string; ext: string } | null)[]
  >([]);
  const [showCoinsModal, setShowCoinsModal] = useState<{
    visible: boolean;
    type: string;
  }>({ visible: false, type: '' });

  console.log('props type', props.type);
  const prevFile = searchParams.get('prevFile');
  const isQuestionnaire = props.type === DOCTYPE.questionnaire;
  const dropzoneAccept = useMemo(
    () =>
      isQuestionnaire
        ? [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            '.xls',
            '.xlsx'
          ]
        : [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            '.pdf',
            '.docx'
          ],
    [isQuestionnaire]
  );

  const handleInputChange = useCallback(
    async (files: File[]) => {
      setFileError([]);

      if (props.type === DOCTYPE.questionnaire) {
        // get file type
        console.log('e target files', files);
        if (files.length === 0) {
          setFilesToUpload([]);
        }

        const fileType = await detectFileType(files[0]);
        setDeterminedFileType(fileType ?? null);
        console.log('file type in selector:', fileType);
        console.log('file type', fileType);
        setValue(files);
        // decide what type of processing docx or xls
        if (fileType?.mime === 'sheet') {
          // create a dcoument in mongo.
        } else {
          setDocProcessing(true);

          const fileResults = await createParagraphs(
            files,
            props.projectId,
            props.folderId
          );
          if (fileResults !== null) {
            console.log('setting uploads', fileResults);
            setFilesToUpload(fileResults);
          }
          setDocProcessing(false);
          setAllowUpload(true);
        }
      } else {
        // this is handling multiple files only pdf format and not encrypted
        console.log('e target files', files);
        if (files.length === 0) {
          setFilesToUpload([]);
          setValue([]);
          setFileError([]);

          return;
        }
        const isEncryptedArray = [];

        // const isEncryptedResult = await isEncrypted(files[0]);
        const fileTypeArrayLoc = [];

        for (const file of files) {
          // isEncryptedArray.push(await isEncrypted(file));
          const fileEncrypted = await isEncrypted(file);
          if (fileEncrypted) {
            isEncryptedArray.push('Encrypted');
          } else {
            isEncryptedArray.push('');
          }
          fileTypeArrayLoc.push(await detectFileType(file));
        }
        console.log('is encrypted result', isEncryptedArray);
        console.log('filetype array', fileTypeArrayLoc);
        setFileError(isEncryptedArray);
        setValue(files);
        setFileTypeArray(fileTypeArrayLoc);
        setDocProcessing(true);
        setDocProcessing(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      props.type,
      props.projectId,
      props.folderId,
      setFilesToUpload,
      setDeterminedFileType,
      setValue,
      setDocProcessing,
      setAllowUpload,
      setFileError,
      setFileTypeArray,
      createParagraphs,
      detectFileType,
      isEncrypted
    ]
  );

  useEffect(() => {
    setUploadProcessing(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRFPUpload = async (goToFile?: boolean) => {
    console.log('Mime Type', determinedFileType?.mime);
    if (determinedFileType?.mime === 'sheet') {
      console.log('uploading a sheet file');
      setUploadProcessing(true);

      for (let i = 0; i < value.length; i++) {
        // check if file is encrypted
        const docCreateResult = await axios.post(
          `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
          {
            documentFileName: value[i].name,
            documentType: prevFile ? DOCTYPE.prevRfp : DOCTYPE.rfp,
            project: props.projectId,
            folder: props.folderId,
            status: 'needs confirmation',
            fileExt: determinedFileType.ext,
            company_for: qaOrigin ?? '',
            company_contact_person: qaContact ?? ''
          },
          auth
        );
        // const fileType =
        const presignedUrl = await axios.post(
          `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadRFP`,
          {
            // customerId: `${user.customerId}`,
            documentId: `${docCreateResult.data.result._id}.${determinedFileType.ext}`
          },
          auth
        );
        const currentFile = value[0];
        const fileBody = new FormData();
        fileBody.append(`sheet`, currentFile);
        console.log('presignedUrl', presignedUrl.data);
        try {
          const putResult = await axios.put(
            presignedUrl.data.url,
            currentFile,
            {
              headers: {
                'Content-Type': currentFile.type || 'application/vnd.ms-excel'
              }
            }
          );
          console.log('put file result', putResult);
          setUploadProcessing(false);
          getAllDocs();
          if (goToFile) {
            navigate(
              `/app/rfp-upload?documentId=${docCreateResult.data.result._id}&projectId=${props.projectId}`
            );
          } else {
            handleCancel();
          }
        } catch (e) {
          console.log('e', e);
        }
      }
    } else {
      uploadFiles(props.type);
    }
  };
  const handleCancel = () => {
    if (props.handleModalCancel) {
      setValue([]);
      props.handleModalCancel(false);
    } else {
      navigate(`/app/projects/${props.projectId}/folder/${props.folderId}`);
    }
  };

  //TODO remove this it is a test for docx only
  const handleUploadFile = async () => {
    if (value.length === 0) return;
    // check for file type make sure only pdf accepted.

    try {
      setUploadProcessing(true);

      // websocket connection only needed for docx files.
      const ws = await createWSConnection(token);
      console.log('ws connection', ws);
      const connectionIdData = await waitForMessage(
        ws,
        (msg) => {
          return msg.type === 'connectionId';
        },
        300000
      ); // 30s timeout
      console.log('connectionData', connectionIdData);
      if (!ws || !connectionIdData.connectionId) {
        console.log('no ws or connection id');
        return;
      }
      const docxFiles = [];
      const pdfFiles = [];
      const imageFiles = [];
      for (let i = 0; i < fileTypeArray.length; i++) {
        if (fileTypeArray[i]?.mime === 'docx') {
          docxFiles.push(value[i]);
        }
        if (fileTypeArray[i]?.mime === 'pdf') {
          pdfFiles.push(value[i]);
        }
        if (
          fileTypeArray[i]?.mime === 'jpeg' ||
          fileTypeArray[i]?.mime === 'png'
        ) {
          imageFiles.push(value[i]);
        }
      }
      // check the pdf files for pages
      const pageCountArray = [];
      let pdfPageCount = 0;
      let docxPageCount = 0;
      for (const file of pdfFiles) {
        const filePages = await getPDFPageCount(file);
        console.log('filePages', filePages);
        pdfPageCount += filePages;
        pageCountArray.push(filePages);
      }
      console.log('page PDF count array', pageCountArray);

      const docxPageCountArray = [];
      // get all the docx page counts
      if (ws && connectionIdData.connectionId) {
        // now do the docx files
        for (const docx of docxFiles) {
          const docxResult = await getDOCXPageCount(
            ws,
            docx,
            connectionIdData.connectionId,
            auth
          );
          console.log('docxResult', docxResult);
          docxPageCount += Number(docxResult.data.pageCount);
          docxPageCountArray.push(docxResult.data);
        }
        console.log('docx Page results', docxPageCount);
      }
      const totalPageCount = docxPageCount + pdfPageCount + imageFiles.length;

      let enoughCredit = false;
      const haveEnoughCredit = await axios.post(
        `${process.env.REACT_APP_KORU_API}/credit?type=verifyCreditHold`,
        {
          type: 'analysis',
          numberOfPages: totalPageCount
        },
        auth
      );
      console.log('credit result', haveEnoughCredit);
      if (haveEnoughCredit?.data?.result?.message === 'Have Enough Credit') {
        enoughCredit = true;
      }
      if (enoughCredit) {
        for (let i = 0; i < pdfFiles.length; i++) {
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: pdfFiles[i].name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId
            },
            auth
          );
          const creditHold = await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: 'analysis',
              numberOfPages: pageCountArray[i],
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=upload`,
            {
              // customerId: `${user.customerId}`,
              documentId: `${docCreateResult.data.result._id}.pdf`
            },
            auth
          );
          const currentFile = pdfFiles[i];
          console.log('presigendUrl', presignedUrl.data);
          const putResult = await axios.put(
            presignedUrl.data.url,
            currentFile,
            {
              headers: {
                'Content-Type': 'application/pdf'
              }
            }
          );
          console.log('put file result', putResult);
        }
        for (let i = 0; i < docxFiles.length; i++) {
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: docxFiles[i].name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId
            },
            auth
          );
          const creditHold = await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: 'analysis',
              numberOfPages: Number(docxPageCountArray[i].pageCount),
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          const moveFilesToDropBucket = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=moveConvertedFile`,
            {
              documentId: `${docCreateResult.data.result._id}.pdf`,
              key: docxPageCountArray[i].key
            },
            auth
          );
          console.log('move file result', moveFilesToDropBucket.data);
        }
        for (let i = 0; i < imageFiles.length; i++) {
          const ext = await detectFileType(imageFiles[i]);
          const docCreateResult = await axios.post(
            `${process.env.REACT_APP_KORU_API}/document?type=addNew`,
            {
              documentFileName: imageFiles[i].name,
              documentType: DOCTYPE.analysis,
              project: props.projectId,
              folder: props.folderId
            },
            auth
          );
          const creditHold = await axios.post(
            `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
            {
              type: 'analysis',
              numberOfPages: 1,
              documentId: docCreateResult.data.result._id
            },
            auth
          );
          const presignedUrl = await axios.post(
            `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadImage&ext=${ext?.ext}`,
            {
              // customerId: `${user.customerId}`,
              documentId: `${docCreateResult.data.result._id}`
            },
            auth
          );
          const currentFile = imageFiles[i];
          console.log('presigendUrl', presignedUrl.data);
          const putResult = await axios.put(
            presignedUrl.data.url,
            currentFile,
            {
              headers: {
                'Content-Type': `${ext?.mime}`
              }
            }
          );
          console.log('put file result', putResult);
        }
        ws.close();
        setUploadProcessing(false);
        getAllDocs();
        handleCancel();
      } else {
        setUploadProcessing(false);
        setShowCoinsModal({ visible: true, type: 'BuyMore' });
      }
    } catch (e) {
      console.log('upload error', e);
      const error = e as Error;
      setMainAlert({
        showAlert: true,
        alertType: 'error',
        message: `File Creation Error - ${error.message}`
      });
    }
  };
  useEffect(() => {
    if (value.length > 0 && fileError.length === 0 && props.projectId) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
  }, [value, fileError]);

  const uploadButtonDisabled = useMemo((): boolean => {
    let returnValue = true;
    const errors = fileError.some((ele) => ele !== '');
    if (props.type === DOCTYPE.questionnaire) {
      if (value.length === 1 && !errors) {
        return false;
      }
    }
    if (props.type === DOCTYPE.analysis) {
      if (value.length > 0 && !errors) {
        return false;
      }
    }
    return returnValue;
  }, [fileError, props.type, value.length]);

  return (
    <Container
      header={
        <Header
          actions={
            <SpaceBetween direction="horizontal" size={'s'}>
              {props.type === DOCTYPE.questionnaire && (
                <Button
                  // onClick={() => uploadFiles(props.type)}
                  // disabled={!(filesToUpload.length === 1)}
                  disabled={!allowUpload}
                  // disabled={value.length === 0}
                  loading={uploadProcessing}
                  onClick={() => handleRFPUpload(true)}
                >
                  Upload & Verify
                </Button>
              )}
              <Button
                // onClick={() => uploadFiles(props.type)}
                // disabled={!(filesToUpload.length === 1)}
                disabled={uploadButtonDisabled}
                // disabled={value.length === 0}
                loading={uploadProcessing}
                onClick={
                  props.type === DOCTYPE.questionnaire
                    ? () => handleRFPUpload()
                    : () => handleUploadFile()
                }
              >
                Upload Documents
              </Button>
              <Button
                onClick={() => handleCancel()}
                // disabled={!(filesToUpload.length === 1)}
              >
                Cancel
              </Button>
            </SpaceBetween>
          }
        ></Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* <FormField label="Folder Name" >
          <Input value={currentFolder} type='text' onChange={({detail}) => setCurrentFolder(detail.value)} />
        </FormField> */}

        <FormField>
          {!docProcessing ? (
            <SpaceBetween direction="vertical" size="s">
              {props.type === DOCTYPE.questionnaire && (
                <FileUpload
                  onChange={({ detail }) => {
                    // setShowCSVImporter(!showCSVImporter);
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag File or Click to upload',
                    dropzoneText: (e) => 'Drop file to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={
                    props.type === DOCTYPE.questionnaire
                      ? '.xlsx or .xls'
                      : '.pdf'
                  }
                  multiple={false}
                  accept={
                    props.type === DOCTYPE.questionnaire
                      ? '.xlsx, .xls'
                      : '.pdf'
                  }
                  fileErrors={fileError}
                />
              )}
              {props.type === DOCTYPE.analysis && (
                <FileUpload
                  onChange={({ detail }) => {
                    // setShowCSVImporter(!showCSVImporter);
                    handleInputChange(detail.value);
                  }}
                  value={value}
                  i18nStrings={{
                    uploadButtonText: (e) => 'Drag Files or Click to upload',
                    dropzoneText: (e) => 'Drop files to upload',
                    removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                    limitShowFewer: 'Show fewer files',
                    limitShowMore: 'Show more files',
                    errorIconAriaLabel: 'Error'
                  }}
                  showFileLastModified
                  showFileSize
                  showFileThumbnail
                  tokenLimit={3}
                  constraintText={'Supported Formats: PDF, DOCX, PNG, JPEG'}
                  multiple={true}
                  accept={'.pdf, .docx, .jpeg, .png'}
                  fileErrors={fileError}
                />
              )}
            </SpaceBetween>
          ) : (
            <SpaceBetween direction="vertical" size="s">
              <TextContent>
                <p>Processing Document for upload</p>
              </TextContent>
              <Spinner size="large" />
            </SpaceBetween>
          )}
        </FormField>
      </SpaceBetween>
      <Modal
        visible={showCoinsModal.visible}
        onDismiss={() => setShowCoinsModal({ visible: false, type: '' })}
      >
        <>
          {showCoinsModal.type === 'BuyMore' ? (
            <div>
              <p className="text-sm text-gray-700 mb-4">
                You do not have enough Compliance Credits to perform this
                document analysis. To continue using advanced features like
                document analysis and AI answers, additional credits are
                required.
              </p>
              {user?.isAdmin ? (
                <Button
                  onClick={() => {
                    setShowCoinsModal({ visible: false, type: '' });
                    setSubsAlert('', 'coins');
                  }}
                  // className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
                >
                  Buy More Credits
                </Button>
              ) : (
                <button
                  className="bg-gray-400 text-white font-medium py-2 px-4 rounded cursor-not-allowed"
                  disabled
                >
                  Contact your administrator to purchase more credits
                </button>
              )}
            </div>
          ) : null}
          {showCoinsModal.type === 'Warning' ? (
            <div>
              <p className="text-sm text-gray-700 mb-4">
                You are running low on compliance credits. To continue using
                advanced features like document analysis and AI answers, we
                suggest buying additional coins to prevent interruptions.
              </p>
              {user?.isAdmin ? (
                <p className="text-sm text-gray-700 mb-4">
                  Navigate to the "View Credit Usage" page to purchase more.
                </p>
              ) : (
                <p className="text-sm text-gray-700 mb-4">
                  Contact you administrator to have them purchase more.
                </p>
              )}
            </div>
          ) : null}
        </>
      </Modal>
      {uploadProcessing && <KoruLoading centerText="Processing Documents..." />}
    </Container>
  );
};
